const rateLimitMap = new Map();

export default function rateLimitMiddleware(handler, customRateLimit) {
  return (req, res) => {
    const ip = req.headers["x-forwarded-for"] || req.connection.remoteAddress;
    let limit = 10; // Limiting requests to 10 per minute per IP
    let windowMs = 60 * 1000; // 1 minute

    if (!rateLimitMap.has(ip)) {
      rateLimitMap.set(ip, {
        count: 0,
        lastReset: Date.now()
      });
    }

    if (customRateLimit) {
      if (customRateLimit.limit) {
        limit = customRateLimit.limit;
      }
      if (customRateLimit.windowMs) {
        windowMs = customRateLimit.windowMs;
      }
    }

    const ipData = rateLimitMap.get(ip);

    if (Date.now() - ipData.lastReset > windowMs) {
      ipData.count = 0;
      ipData.lastReset = Date.now();
    }

    if (ipData.count >= limit) {
      return res.status(429).send("Too Many Requests");
    }

    ipData.count += 1;

    return handler(req, res);
  };
}

const rateLimiterDownloadIMGMap = new Map();

export const rateLimiterDownloadIMG = (db_id, customRateLimit) => {
  return async (url) => {
    const id = db_id;
    let limit = 10; // Limiting requests to 10 per minute per id
    let windowMs = 60 * 1000; // 1 minute

    if (!rateLimiterDownloadIMGMap.has(id)) {
      rateLimiterDownloadIMGMap.set(id, {
        count: 0,
        lastReset: Date.now()
      });
    }

    if (customRateLimit) {
      if (customRateLimit.limit) {
        limit = customRateLimit.limit;
      }
      if (customRateLimit.windowMs) {
        windowMs = customRateLimit.windowMs;
      }
    }

    const ipData = rateLimiterDownloadIMGMap.get(id);

    if (Date.now() - ipData.lastReset > windowMs) {
      ipData.count = 0;
      ipData.lastReset = Date.now();
    }

    if (ipData.count >= limit) throw new Error("Too Many Requests, Please try again.");

    ipData.count += 1;

    return fetch(url)
      .then((res) => res.arrayBuffer())
      .then((buff) => new Blob([buff], { type: "image/jpeg" }));
  };
};
